import React from 'react'

const Search = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="103.01" height="102.932" viewBox="0 0 103.01 102.932" {...props}>
    <path
      id="Magnifier"
      d="M99.8,102.932a3.189,3.189,0,0,1-2.268-.943l-31.1-31.4A40.18,40.18,0,0,1,11.75,11.781,40.122,40.122,0,0,1,80.241,40.225,40.35,40.35,0,0,1,70.923,66l31.149,31.434a3.235,3.235,0,0,1,0,4.553A3.189,3.189,0,0,1,99.8,102.932ZM40.119,6.391A33.837,33.837,0,1,0,73.85,40.228,33.821,33.821,0,0,0,40.119,6.391Z"
    />
  </svg>
)

export default Search
